<section class="feature-section">
  <div>
    <h2 l10nTranslate>Advanced Technical Features</h2>
    <h6 l10nTranslate [innerHTML]="'to satisfy regulatory requirements related to software and to scale and integrate easily with your internal systems'"></h6>
  </div>
  <div class="feature-section__cards">
    <ng-container *ngFor="let item of sectionInputTwoCards">
      <div class="container__card">
        <img src="{{ item?.imagePath }}" />
        <div l10nTranslate class="card__description" [innerHTML]="item?.description">
        </div>
      </div>
    </ng-container>
  </div>
</section>
